import React from 'react';
import { Typography } from '@mui/material';
import { useRootStore } from '@hooks/useRootStore';

interface ProtectedRouteProps {
    allowedRoles: string[];
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles, children }) => {
    const { authorizationStore } = useRootStore();
    const { user } = authorizationStore;

    if (user === null || user.userRole === undefined || user.userRole === null) {
        return <Typography variant='h1'>Nemate ovlasti pristupa!</Typography>
    }

    if (!allowedRoles.includes(user.userRole.name)) {
        return <Typography variant='h1'>Nemate ovlasti pristupa!</Typography>
    }

    return (
        children
    )
}

export default ProtectedRoute;